import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import styles from './Descripcion.module.css'
import Metadatos from './Metadatos'

const LONGITUD_TEXTO = 300
const Descripcion = ({ descripcion, idPublicacion }) => {
  const [expanded, setExpanded] = useState(false)
  const [textoCorto, setTextoCorto] = useState('')

  useEffect(() => {
    if (descripcion) {
      setTextoCorto(descripcion.slice(0, LONGITUD_TEXTO))
    }
  }, [descripcion])
  const esLargo = descripcion && descripcion.length > LONGITUD_TEXTO
  return (
    <div className="row">
      <div className="col">
        <div className={styles.contenedor}>
          <p className={styles.titulo}>Descripcion</p>
          <p className={styles.descripcionTexto}>{expanded ? descripcion : textoCorto}</p>
          {esLargo && (
            <button className={styles.btnVerMas} onClick={() => setExpanded(!expanded)}>
              {expanded ? 'Ver menos' : 'Ver más'}
            </button>
          )}
          {idPublicacion && (
            <div className={styles.metadatosSeccion}>
              <Metadatos idPublicacion={idPublicacion} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

Descripcion.propTypes = {
  descripcion: PropTypes.string.isRequired,
  idPublicacion: PropTypes.number
}

export default Descripcion
